import { Box, Text } from '@chakra-ui/react'

export const ThreeDViewer = () => {
  return (
    <Box p={4} bg="white" borderRadius="lg" shadow="sm" height="full">
      <Text fontSize="lg" fontWeight="bold" mb={4}>3D Model</Text>
      {/* Three.js viewer will go here */}
    </Box>
  )
}
